export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img src="/img/logo-tile.png" alt="Sweet Results logo" className={`${className} rounded-[22%] object-contain`} />
);

export const Logo = () => (
  <a href="/#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
    <LogoMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[-8deg] group-hover:scale-105" />
    <span className="font-display font-extrabold tracking-tight text-base sm:text-lg leading-none">
      Sweet<span className="text-duo">Results</span>
    </span>
  </a>
);
